import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {plugins, options } from './config';

import './index.scss';

ChartJS.register(
  ChartDataLabels,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const StackedChart = ({ labels, acceptData, declineData }) => {
  const data = {
    labels: labels,
    datasets: [
      {
        label: 'Accepts',
        data: acceptData,
        backgroundColor: '#0994A9',
        borderColor: '#0994A9',
        hoverBackgroundColor: '#94CEDA',
      },
      {
        label: 'Declines',
        data: declineData,
        backgroundColor: '#E3414B',
        borderColor: '#E3414B',
        hoverBackgroundColor: '#EDACB3',
      },
    ],
  }

  return  <div className='bar-wrap'>
    <Bar options={options} plugins={plugins} data={data} />
  </div>
};

export default StackedChart;
